// Constants for the shared contact create/edit dialog (financial-hub / BBR).
// Moved out of the component per the project constants-over-magic-strings convention.

export const CONTACT_FORM_DIALOG_LABEL = {
  CREATE_TITLE: 'Create contact',
  EDIT_TITLE:   'Edit contact',
  NAME:         'Name',
  EMAIL:        'Email',
  PHONE:        'Phone',
  JOB_TITLE:    'Job title',
  CREATE:       'Create contact',
  SAVE:         'Save changes',
  CREATED:      'Contact created.',
  SAVED:        'Contact updated.',
  LOAD_FAILED:  'Could not load the contact. Please try again.',
  CREATE_FAILED: 'Could not create the contact. Please try again.',
  SAVE_FAILED:  'Could not update the contact. Please try again.',
  REQUIRED:     '*Required',
  EMAIL_ERROR:  'Enter a valid email address.',
  // INI-13919-79: shown under the email input when the duplicate pre-check finds an exact match.
  EMAIL_DUPLICATE: 'This email is already registered.',
} as const;

// INI-13919-79: duplicate-email pre-check against GET /contacts (BBR-native global directory).
// The backend's `limit` query param is an enum of 10/20/30 — 30 maximizes coverage of the
// exact-match scan. Best-effort only: the authoritative uniqueness check belongs in
// makers-finances-mgr (POST /contacts), which does not enforce it yet.
export const CONTACT_DUPLICATE_CHECK_PAGE = 1;
export const CONTACT_DUPLICATE_CHECK_PAGE_SIZE = 30;
// Defensive ceiling for the paginated scan: `q` matches names as well as emails, so a common
// substring can span many pages. Past this cap the pre-check is inconclusive and the backend
// stays the source of truth — the scan must never loop on a broken total_page.
export const CONTACT_DUPLICATE_CHECK_MAX_PAGES = 10;
